/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
const ToastContext = createContext(null);
function useToast() {
    return useContext(ToastContext);
}
export { ToastContext, useToast };
